import { Reveal, SectionHeading } from "./shared";
import { WITNESS } from "../../data";

export default function Witness() {
  return (
    <section id="witness" className="relative py-28 md:py-40 bg-[#0f1724]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <SectionHeading
          chapter="03 // WITNESS LOGS"
          title={<>What the<br />humans saw</>}
          kicker="Testimony is read against the instrument record, so investigators can see where a person's account confirms the data — and where someone noticed what the instruments could not."
        />

        <div className="space-y-px border-t border-white/10">
          {WITNESS.map((w, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div
                data-testid={`witness-${i}`}
                className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-10 border-b border-white/10 transition-colors duration-500 hover:bg-[#152430] px-2 md:px-4"
              >
                <div className="md:col-span-3">
                  <div className="font-display font-bold text-white text-lg tracking-tight">{w.role}</div>
                  <div className="font-mono-data text-[10px] tracking-[0.2em] text-[#b88457] mt-2">{w.id}</div>
                </div>
                <blockquote className="md:col-span-9 relative">
                  <span className="absolute -left-4 -top-4 font-display text-5xl text-white/10 select-none">“</span>
                  <p className="text-zinc-300 text-lg md:text-2xl leading-relaxed font-light">{w.quote}</p>
                </blockquote>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-10 flex items-center gap-4 font-mono-data text-[11px] tracking-[0.2em] text-zinc-500">
            <span className="w-1.5 h-1.5 bg-[#b88457] cursor-blink" />
            CORRELATION: FIELD OP WHINE @ 03:13 ↔ AUDIO FREQ SPIKE 4.2 kHz ↔ V-402A CAVITATION
          </div>
        </Reveal>
      </div>
    </section>
  );
}
